export const scrollToEvent = (offset, callback) => {
  const fixedOffset = offset.toFixed();
  const onScroll = function () {
    if (window.scrollY.toFixed() === fixedOffset) {
      window.removeEventListener('scroll', onScroll);
      callback();
    }
  };

  window.addEventListener('scroll', onScroll);
  onScroll();
  window.scrollTo({
    top: offset,
    behavior: 'smooth',
  });
};

export const getIndex = (item) => {
  const nodes = Array.prototype.slice.call(item.parentElement.children);
  return nodes.indexOf(item);
};

const hero = document.querySelector('.intro__full_img.__js_preload');
const evenArticles = document.querySelectorAll('article:nth-of-type(2n)');

function updateSidebars() {
  const scrollY = window.scrollY;
  const viewportH = window.innerHeight;

  evenArticles.forEach(article => {
    const articleRect = article.getBoundingClientRect();
    const articleHeight = article.offsetHeight;

    const sidebarBottomAbsolute = articleHeight - viewportH;

    let topOffset, position;

    if (articleRect.top > 0) {
      // START: artykuł jeszcze nie dotknął top viewportu → obrazki przy artykule
      topOffset = 0; // względem artykułu
      position = 'absolute';
    } else if (articleRect.top <= 0 && articleRect.bottom >= viewportH) {
      // Scroll w trakcie artykułu → boczne obrazki fixed
      topOffset = 0;
      position = 'fixed';
    } else {
      // Koniec artykułu → boczne obrazki absolute przy dolnej krawędzi artykułu
      topOffset = sidebarBottomAbsolute;
      position = 'absolute';
    }

    article.style.setProperty('--sidebar-top', `${topOffset}px`);
    article.style.setProperty('--sidebar-position', position);
  });
}

// Start
updateSidebars();

// Aktualizacja przy scroll i resize
window.addEventListener('scroll', updateSidebars);
window.addEventListener('resize', updateSidebars);